import { gql } from '@apollo/client';

const DELETE_CHECK_POINT = gql`
  mutation DeleteCheckPoint($checkPointId: Int!) {
    deleteCheckPoint(checkPointId: $checkPointId)
  }
`;

export default DELETE_CHECK_POINT;
